export const persistLoginState = (state: any): any => ({
  cocap: state.cocap,
  isLogged: state.isLogged,
  loadingStatus: state.isLogged ? 'SUCCESS' : 'NOT_STARTED',
  step: state.isLogged ? 'AUTHENTICATED' : 'IDLE',
  message: '',
  userId: state.userId,
  isVerified: state.isVerified,
  challengeId: '',
  email: '',
  expiresAt: 0,
  resendAt: 0
})
